export const sortCardsByName = (unsortedData: any) => {
  const sortedData = unsortedData.map((item: any) => ({
    ...item,
    cardList: item.cardList.slice().sort((a: any, b: any) => {
      return a.name.localeCompare(b.name)
    }),
  }))

  return sortedData
}
